export const NAME = 'uploadProgress';
const SET_PROGRESS = `SET_PROGRESS_${NAME}`;
const REMOVE_PROGRESS = `REMOVE_PROGRESS_${NAME}`;

export const setUploadProgress = (payload) => ({
	type: SET_PROGRESS,
	payload,
});

export const removeUploadProgress = (uploadKey) => ({
	type: REMOVE_PROGRESS,
	payload: uploadKey,
});

const ACTION_MAP = {
	[SET_PROGRESS]: (state, action) => {
		const { uploadKey, ...rest } = action.payload;
		return {
			...state,
			uploads: {
				...state.uploads,
				[uploadKey]: { uploadKey, ...rest },
			},
		};
	},
	[REMOVE_PROGRESS]: (state, action) => {
		const remaining = { ...state.uploads };
		delete remaining[action.payload];
		return { ...state, uploads: remaining };
	},
};

const initialState = {
	uploads: {},
};

export const reducer = (state = initialState, action) => {
	const actionFunc = ACTION_MAP[action.type];
	return actionFunc ? actionFunc(state, action) : state;
};
